// extracted by mini-css-extract-plugin
export default {"partner-wgg-logo":"PartnerWggLogo_partner-wgg-logo__CT4Zi"};